import { render } from "./TokenGenerator.vue?vue&type=template&id=66f7377a"
import script from "./TokenGenerator.vue?vue&type=script&lang=js"
export * from "./TokenGenerator.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__